export const myLocationProfileQuery = `query getMyLocationProfile ($locationId: ID!) {
      locationProfile  (id: $locationId) {
        companyName
        locationName
        id
        companyId
        isMarketingReady
        name
        coverImageUrl
        marketSegments
        companyTypes
        website
        phone
        productType
        amenities
        locationId
        roomCount
        isProductMarketingReady
        rating {
          value
          type
        }
        profileImageUrl
        imageUrls
        profileViews {
          timeViewed
          profileImageUrl
          companyId
          companyName
        }
        address {
          addressOne
          addressTwo
          city
          state
          country
          postalCode
          formattedAddress
        }
        type
        notes
        description
        contacts {
          firstName
          lastName
          name
          type
          phone
          fax
          email
        }
        groups {
          _id
          tag
          items
        }
        products {
          name
          id
          images
          isMarketingReady
          updatedAt
        }
      }
    }`;


export const addProductMutation = `mutation addProduct($supplierId:ID!, $locationId: ID!, $name: String!) {
  addProduct (locationId: $locationId, supplierId: $supplierId, name: $name) {
    name
    productId
    locationId
  }
}`;

export const editLocationMutation = `mutation editLocation($locationId: ID!, $supplierId: ID!, $update: LocationProfileInputType) {
  editLocation (locationId: $locationId, supplierId: $supplierId, update: $update) {
    isMarketingReady
    isProductMarketingReady
    locationId
  }
}`;



// WEBPACK FOOTER //
// ./src/app/stores/profile/location/location-graphql-query.js